export class InventoryLine {
  constructor(private readonly name: string, private readonly count: number, private readonly percentage: number | null) {}

  getName() {
    return this.name;
  }

  getCount() {
    return this.count;
  }

  getPercentage() {
    return this.percentage;
  }
}
